export interface HomeUrlResponse {
  homeUrl: string | null;
}

async function getHomeUrl(): Promise<HomeUrlResponse> {
  try {
    const resp = await fetch('/getHomeUrl');
    if (!resp.ok) {
      throw new Error(`Failed to fetch home URL: ${resp.status} ${resp.statusText}`);
    }
    const json = await resp.json();
    return json;
  } catch (error) {
    console.error('Error fetching home URL:', error);
    throw error;
  }
}

export default getHomeUrl;

